module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right",
    attrs: {
      "id": "underdesign"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/content_underdesign.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3595de18!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/underdesign.vue
// module id = 113
// module chunks = 5 6 7 8